<template>
  <div></div>
</template>
<script>
import { useToast } from "vue-toastification"
import TopActionToast from "@/components/common/TopActionToast.vue"

export default {
  mounted() {
    this.toast = useToast()
  },
  methods: {
    show(props) {
      this.toast({
        component: TopActionToast,
        props
      })
    }
  }
}
</script>
